<div
  class="med-sidebar__content"
  #contentRef
  [ngStyle]="styleList"
>
  <ng-content></ng-content>
</div>

<ng-container *ngTemplateOutlet="btnTemplate || null"></ng-container>
